export default "__VITE_ASSET__BLhJEw3$__"